<template>
  <v-layout column>
    <toolbar :loading="!_.get(currentLoad, 'humanId', null)"
             :title="`Load ${_.get(currentLoad, 'humanId', null)} ${_.get(currentLoad, 'loadStatus', 'Unknown')}`">
      <v-icon @click="refreshCurrentLoad()">refresh</v-icon>
    </toolbar>

    <load-detail-component :currentLoad="currentLoad" v-if="currentLoad"
                           class="pl-2"
                           :company="company"
                           :loading="loadingLoad"
                           @removeLoad="removeLoad($event)"
                           @refreshLoad="refreshCurrentLoad">
    </load-detail-component>
  </v-layout>

</template>

<script>
import _ from 'lodash';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import companyNamesMixin from '@/mixins/companyNames';
import refreshPageMixin from '@/mixins/refreshPageMixin';

import Toolbar from '@/components/Toolbar';

import LoadDetailComponent from '@/components/dashboard/simple/LoadDetail';

import * as Loads from '@/types/models/load';

export default {
  name: 'LoadDetail',
  mixins: [companyNamesMixin, refreshPageMixin],
  data: () => ({
    currentLoad: null,
  }),
  components: {
    Toolbar,
    LoadDetailComponent,
  },
  props: {
    loadId: {
      type: String,
      required: true,
    },
    loadNonce: {
      type: String,
      required: false,
    }
  },
  computed: {
    _() {
      return _;
    },
    company() {
      return this.listingCompany;
    },
    loadingLoad() {
      return false; // TODO: do this
    },
    listingCompany() {
      return Loads.listingCompany(this.currentLoad);
    },
    truckingCompany() {
      return Loads.carrierCompany(this.currentLoad) || {};
    },
    pickupCompany() {
      return Loads.pickupCompany(this.currentLoad);
    },
    dropoffCompany() {
      return Loads.dropoffCompany(this.currentLoad);
    },
    loadDetails() {
      return Loads.listingDetails(this.currentLoad);
    },
    listing() {
      return Loads.listingDetails(this.currentLoad);
    },
    tacticalInfo() {
      return _.get(this.currentLoad, 'tacticalInfo', {});
    },
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapGetters('applications', [
      'signedIn',
      'isNonceUser',
    ]),

    loadCompanies() {
      const companies = {};
      if (this.listingCompanyProfile) {
        companies[this.listingCompanyProfile.id] = this.listingCompanyProfile;
        companies[this.listingCompanyProfile.id.toString()] = this.listingCompanyProfile;
      }
      if (this.truckingCompanyProfile) {
        companies[this.truckingCompanyProfile.id] = this.truckingCompanyProfile;
        companies[this.truckingCompanyProfile.id.toString()] = this.truckingCompanyProfile;
      }
      if (this.pickupCompanyProfile) {
        companies[this.pickupCompanyProfile.id] = this.pickupCompanyProfile;
        companies[this.pickupCompanyProfile.id.toString()] = this.pickupCompanyProfile;
      }
      if (this.dropoffCompanyProfile) {
        companies[this.dropoffCompanyProfile.id] = this.dropoffCompanyProfile;
        companies[this.dropoffCompanyProfile.id.toString()] = this.dropoffCompanyProfile;
      }

      return companies;
    },
  },
  watch: {
    currentLoad(currentLoad) {
      if (_.get(currentLoad, 'billOfLading.link', null)) {
        if (this.$route.query.view === 'doc:bol') {
          const query = _.clone(this.$route.query);
          delete query.view;
          this.$router.replace({ query });

          this.openBillOfLading();
        }
      }
    },
  },
  methods: {
    async openBillOfLading() {
      const url = this.currentLoad.billOfLading.link;
      this.$store.dispatch('lightbox/show', url);
    },

    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
    onRefresh() {
      this.refreshCurrentLoad();
    },
    async getLoad(params) {
      await API.load.getLoad(params);
    },
    async refreshCurrentLoad() {
      this.$store.dispatch('applications/addLoading', [
        this.loadCurrentLoad(),
      ]);
    },
    async loadCurrentLoad() {
      // what about the nonce load ...
console.log('pages/Loads/Detail: loadCurrentLoad for ' + this.loadId);
      const response = await API.load.getLoad({ loadId: this.loadId });
      this.currentLoad = response.data;

      this.loadCompaniesProfile();

      const driverUserId = _.get(this.tacticalInfo, 'assignedTruckingCompanyDriverUserId', null);
      if (driverUserId) {
console.log('pages/Loads/Detail: loadCurrentLoad.getUserProfile(driver)');
        const driverResponse = await API.user.getUserProfile({ userId: driverUserId });
        this.driver = driverResponse.data;
      }
    },
    loadCompaniesProfile() {
      if (this.listingCompany) {
console.log('pages/Loads/Detail: loadCompaniesProfile.listingCompany');
        API.company.byId({ id: this.listingCompany.id }).then((apiResponse) => {
          this.listingCompanyProfile = apiResponse.data;
        });
      }

      if (this.truckingCompany && this.truckingCompany.id) {
console.log('pages/Loads/Detail: loadCompaniesProfile.truckingCompany');
        API.company.byId({ id: this.truckingCompany.id }).then((apiResponse) => {
          this.truckingCompanyProfile = apiResponse.data;
        });
      }

      if (_.get(this.pickupCompany, 'id', false)) {
console.log('pages/Loads/Detail: loadCompaniesProfile.pickupCompany');
        API.company.byId({ id: this.pickupCompany.id }).then((apiResponse) => {
          this.pickupCompanyProfile = apiResponse.data;
        });
      }

      if (_.get(this.dropoffCompany, 'id', false)) {
console.log('pages/Loads/Detail: loadCompaniesProfile.dropoffCompany');
        API.company.byId({ id: this.dropoffCompany.id }).then((apiResponse) => {
          this.dropoffCompanyProfile = apiResponse.data;
        });
      }
    },
    initData() {
      const loadPromise = this.loadCurrentLoad();

      this.$store.dispatch('applications/addLoading', [
        loadPromise,
      ]);
    },
  },
  created() {
    window.__insp.push(['tagSession', 'open_load_detail']);
    this.$ga.event({
      eventCategory: 'open_section',
      eventAction: 'load_detail',
      eventLabel: this.loadId,
    });
console.log('pages/Loads/Detail created(). signedIn? ' + this.signedIn, 'loadId: ', this.loadId);
    if (this.signedIn) {
      this.initData();
    } else {
      // this.$store.dispatch('applications/addLoading');
      this.$bus.$once('loginWithNonce', this.initData);
    }
  },
};
</script>

<style scoped>
  a {
    text-decoration:none;
  }
</style>

<style>
  @media only screen and (max-width: 959px) {
    .deliver-dialog .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Loads/Detail.vue